package com.schoolconnect.app.feature.splash

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

class SplashViewModel {
    private val _uiState = MutableStateFlow(SplashUiState())

    val uiState: StateFlow<SplashUiState> = _uiState.asStateFlow()
}
